import { makeStyles, shorthands } from '@fluentui/react-components';

export const useImageCardStyles = makeStyles({
  imageCardListItem: {
    marginRight: '16px',
  },
  imageCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '194px !important',
    height: '220px !important',
    pointerEvents: 'auto',
  },
  imageCardThumbnail: {
    width: '194px !important',
    height: '160px !important',
    objectFit: 'cover',
    ...shorthands.overflow('hidden'),
  },
  imageCardFooter: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    height: '60px !important',
    width: '194px !important',
    paddingLeft: '15px !important',
  },
  imageCardFooterContent: {
    display: 'flex',
    rowGap: '0px !important',
    paddingBottom: '2px !important',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.gap('4px'),
  },
  imageIconAndName: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
  },
  imageName: {
    width: '142px',
    ...shorthands.overflow('hidden'),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  imageCardCaption: {
    paddingBottom: '5px !important',
    paddingLeft: '2px !important',
  },
});
